export default __webpack_public_path__ + "static/media/Julia 9781408336489.6fe75adb.jpg";